/*
 * konfigurator.js — Smart-Home-Konfigurator (dependency-free Insel, WP 7 im Theme).
 *
 * 6-Schritte-Wizard nach den Builder-Designs (Desktop + Mobile, DesignSync):
 *   1 Ziel & Alltag (multi) · 2 Dein Zuhause · 3 Plattform & Technik · 4 Räume & Situationen
 *   5 Prioritäten · 6 Dein Setup (Ergebnis). Plus Express-Modus (3 Fragen -> Schritt 6).
 *
 * Datenquellen (JS bleibt daten- und i18n-rein):
 *   #konfigurator-data     — Blueprints (configurator_goal_bundle-Metaobjekte), Produkt-Map,
 *                            Rabatt-Staffeln, URLs (aus sections/main-konfigurator.liquid)
 *   #konfigurator-strings  — alle Texte per | t aus locales/de.default.json
 *   #compat-finder-data    — Systeme + Hubs + empfohlener Hub (geteilter Datentopf des
 *                            Kompatibilitäts-Finders, Footer-Group). Schritt 3 übernimmt
 *                            dessen Verdikt-Logik: hub.thread === true -> gruen, sonst amber,
 *                            System "none" -> info. KEINE eigene Hub-Datenhaltung.
 *
 * Empfehlungs-Engine (computeSetup): Blueprint des Primärziels (goals[0]) -> Tier-Filter nach
 * Umfang (Schritt 5) -> Aufwands-/Miete-Constraints (swap via alt_no_electric oder drop) ->
 * Raum-Skalierung (per_room) -> Situations-Add-ons (dedupe gegen Items) -> Hub-Zeile nur wenn
 * noetig (hub_required-Geraete + kein Thread Border Router vorhanden) -> Budget-Trimming
 * (nur plus-Tier, nie core/Hub/Add-ons). Alles ehrlich: echte Preise, UVP-Streichpreis nur
 * als Summe echter compare_at-Preise (PAngV, Entscheidung 15).
 *
 * Cart: EIN Add über Homedia.cart.add({items}) (kanonischer Controller, cart.js). Danach
 * /cart/update.js mit { discount, attributes } — Rabattcode-Staffel nur anwenden, wenn der
 * Warenkorbwert die Mindestschwelle erreicht (sonst zeigt der Checkout einen nutzlosen
 * "nicht anwendbar"-Hinweis). Drawer öffnet sich selbst über cart:added (NIE open() danach).
 *
 * Speichern: localStorage 'hm-konfigurator' + Share-Link (?c=<base64url>). Optionaler
 * App-Proxy-Sync (data.proxy, Konfigurator-App): Feature-Detection via GET {proxy}/ping —
 * erst wenn die App antwortet, erscheinen E-Mail-Versand + Konto-Speicherung (docs/25).
 */
(function () {
  'use strict';
  var Homedia = (window.Homedia = window.Homedia || {});
  if (Homedia.konfigurator) return;

  var STORAGE_KEY = 'hm-konfigurator';
  var GOALS = ['licht', 'sicherheit', 'energie', 'komfort', 'miete', 'start'];
  var ROOMS = ['wohnzimmer', 'schlafzimmer', 'kueche', 'flur', 'bad', 'aussen'];
  var SITS = ['abend', 'heim', 'weg', 'nacht', 'sichern', 'heizen'];
  var BUDGET_MAX = { b1: 15000, b2: 40000, b3: 80000, b4: Infinity };
  var RANGE_ROOMS = { r1: 1, r2: 3, r3: 5, r4: 6 };

  function parseJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function decodeEntities(str) {
    if (str == null || String(str).indexOf('&') === -1) return str;
    var ta = document.createElement('textarea');
    ta.innerHTML = str;
    return ta.value;
  }
  function el(tag, cls, attrs) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (attrs) Object.keys(attrs).forEach(function (k) { node.setAttribute(k, attrs[k]); });
    return node;
  }
  function txt(tag, cls, text) {
    var node = el(tag, cls);
    node.textContent = text == null ? '' : text;
    return node;
  }
  function interpolate(tpl, vars) {
    return String(tpl == null ? '' : tpl).replace(/\{(\w+)\}/g, function (m, key) {
      return Object.prototype.hasOwnProperty.call(vars, key) ? vars[key] : m;
    });
  }
  function money(cents) {
    if (Homedia.cart && Homedia.cart.formatMoney) return Homedia.cart.formatMoney(cents);
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }
  function emit(name, detail) {
    try { document.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); } catch (e) {}
  }
  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // ---- Icon-Set (currentColor, stroke-basiert wie snippets/icon.liquid) ----
  var ICONS = {
    bulb: '<path d="M9 18h6M10 21h4"/><path d="M12 3a6 6 0 0 0-4 10.5c.7.6 1 1.5 1 2.5h6c0-1 .3-1.9 1-2.5A6 6 0 0 0 12 3z"/>',
    shield: '<path d="M12 2 4 6v6c0 5 3.5 8 8 10 4.5-2 8-5 8-10V6z"/><path d="m9 12 2 2 4-4"/>',
    bolt: '<path d="M13 2 4 14h7l-1 8 9-12h-7z"/>',
    sparkle: '<path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M5.6 18.4l2.8-2.8M15.6 8.4l2.8-2.8"/>',
    home: '<path d="m3 10 9-7 9 7v10a1 1 0 0 1-1 1h-5v-7h-6v7H4a1 1 0 0 1-1-1z"/>',
    arrow: '<path d="M5 12h14M13 6l6 6-6 6"/>',
    arrowl: '<path d="M19 12H5M11 6l-6 6 6 6"/>',
    check: '<path d="M20 6 9 17l-5-5"/>',
    warn: '<path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/><path d="M12 9v4M12 17h.01"/>',
    info: '<circle cx="12" cy="12" r="9"/><path d="M12 8h.01M11 12h1v4h1"/>',
    sunset: '<path d="M12 10V3M8 7l4-4 4 4"/><path d="M3 17h2a7 7 0 0 1 14 0h2M5 21h14"/>',
    moon: '<path d="M21 13A8.5 8.5 0 0 1 11 3a8.5 8.5 0 1 0 10 10z"/>',
    lock: '<rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>',
    flame: '<path d="M12 3s5 4.5 5 9.5a5 5 0 0 1-10 0c0-2 .8-3.6 2-5 0 1.5.7 2.5 2 3 0-2.5.3-5 1-7.5z"/>',
    save: '<path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><path d="M17 21v-8H7v8M7 3v5h8"/>',
    cart: '<circle cx="9" cy="20" r="1.6"/><circle cx="17" cy="20" r="1.6"/><path d="M3 4h2l2.4 12.2a1 1 0 0 0 1 .8h8.9a1 1 0 0 0 1-.8L20 8H6"/>',
    cam: '<rect x="3" y="7" width="13" height="12" rx="2"/><path d="m16 12 5-3v8l-5-3"/>',
    chat: '<path d="M21 12a8 8 0 0 1-8 8H4l2-3a8 8 0 1 1 15-5z"/>',
    mail: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/>',
    restart: '<path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/>',
    hub: '<rect x="5" y="9" width="14" height="8" rx="2"/><path d="M12 5v4M8 3.5h.01M12 2.5h.01M16 3.5h.01"/>'
  };
  var GOAL_ICON = { licht: 'bulb', sicherheit: 'shield', energie: 'bolt', komfort: 'sparkle', miete: 'home', start: 'arrow' };
  var SIT_ICON = { abend: 'sunset', heim: 'home', weg: 'shield', nacht: 'moon', sichern: 'lock', heizen: 'flame' };
  function svg(name, size) {
    var inner = ICONS[name] || ICONS.sparkle;
    var s = size || 20;
    return '<svg width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ' +
      'aria-hidden="true" focusable="false">' + inner + '</svg>';
  }

  // ---------- State (de-)serialisieren: localStorage + Share-Link ----------
  function blankState() {
    return {
      v: 1, step: 1,
      goals: [],
      home: { form: '', tenure: '', rooms: '', install: '', budget: '' },
      plat: { sys: '', hubKey: '', noHub: false, assumeTbr: false, extras: [] },
      rooms: [], sits: [],
      prefs: { scope: 'ausgewogen', local: false, fewApps: false },
      override: ''
    };
  }
  function sanitizeState(raw) {
    var s = blankState();
    if (!raw || typeof raw !== 'object' || raw.v !== 1) return s;
    if (Array.isArray(raw.goals)) s.goals = raw.goals.filter(function (g) { return GOALS.indexOf(g) !== -1; });
    var st = parseInt(raw.step, 10);
    if (st >= 1 && st <= 6) s.step = st;
    var h = raw.home || {};
    var HOME_OK = {
      form: ['wohnung', 'haus'],
      tenure: ['miete', 'eigentum'],
      rooms: ['r1', 'r2', 'r3', 'r4'],
      install: ['plug', 'screw', 'electric'],
      budget: ['b1', 'b2', 'b3', 'b4']
    };
    Object.keys(HOME_OK).forEach(function (k) {
      if (typeof h[k] === 'string' && HOME_OK[k].indexOf(h[k]) !== -1) s.home[k] = h[k];
    });
    var p = raw.plat || {};
    if (typeof p.sys === 'string') s.plat.sys = p.sys;
    if (typeof p.hubKey === 'string') s.plat.hubKey = p.hubKey;
    s.plat.noHub = p.noHub === true;
    s.plat.assumeTbr = p.assumeTbr === true;
    // Primärsystem und "none" haben in den Zusatz-Apps nichts verloren (heilt alte/geteilte States).
    if (Array.isArray(p.extras)) {
      s.plat.extras = p.extras.filter(function (x) {
        return typeof x === 'string' && x !== s.plat.sys && x !== 'none';
      });
    }
    if (Array.isArray(raw.rooms)) s.rooms = raw.rooms.filter(function (r) { return ROOMS.indexOf(r) !== -1; });
    if (Array.isArray(raw.sits)) s.sits = raw.sits.filter(function (x) { return SITS.indexOf(x) !== -1; });
    var pr = raw.prefs || {};
    if (['kompakt', 'ausgewogen', 'komplett'].indexOf(pr.scope) !== -1) s.prefs.scope = pr.scope;
    s.prefs.local = pr.local === true;
    s.prefs.fewApps = pr.fewApps === true;
    if (['', 'cheap', 'more', 'nohub'].indexOf(raw.override) !== -1) s.override = raw.override;
    return s;
  }
  function encodeState(state) {
    try {
      var json = JSON.stringify(state);
      return btoa(unescape(encodeURIComponent(json))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    } catch (e) { return ''; }
  }
  // Rückgabe { state, stale }: stale = ?c= war vorhanden, aber unbrauchbar (beschädigt, fremde
  // Schema-Version, oder alle Kern-Antworten von den Whitelists verworfen). Der Wizard zeigt dann
  // den „Link ungültig oder veraltet"-Hinweis und startet frisch (docs/25 §7a).
  function decodeState(param) {
    try {
      var b64 = String(param).replace(/-/g, '+').replace(/_/g, '/');
      while (b64.length % 4) b64 += '=';
      var raw = JSON.parse(decodeURIComponent(escape(atob(b64))));
      if (!raw || typeof raw !== 'object' || raw.v !== 1) return { state: null, stale: true };
      var s = sanitizeState(raw);
      var hadGoals = Array.isArray(raw.goals) && raw.goals.length > 0;
      if (hadGoals && !s.goals.length) return { state: s, stale: true };
      return { state: s, stale: false };
    } catch (e) { return { state: null, stale: true }; }
  }
  function persist(state) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
  }
  function readPersisted() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? sanitizeState(JSON.parse(raw)) : null;
    } catch (e) { return null; }
  }

  // ============================================================================
  function init() {
    var mount = document.querySelector('[data-konfigurator]');
    if (!mount || mount.__konfReady) return;

    var data = parseJSON('konfigurator-data');
    var S = parseJSON('konfigurator-strings');
    if (!data || !S || !Array.isArray(data.blueprints) || !data.blueprints.length) return;
    mount.__konfReady = true;
    Object.keys(S).forEach(function (k) { S[k] = decodeEntities(S[k]); });

    // Geteilter Compat-Datentopf (Systeme/Hubs/empfohlener Hub) — Verdikt-Logik von dort.
    var compat = parseJSON('compat-finder-data') || {};
    var systems = Array.isArray(compat.systems) ? compat.systems : [];
    var allHubs = Array.isArray(compat.hubs) ? compat.hubs : [];

    var products = data.products || {};
    var blueprints = {};
    data.blueprints.forEach(function (bp) { if (bp && bp.key) blueprints[bp.key] = bp; });
    var discounts = (Array.isArray(data.discounts) ? data.discounts : [])
      .filter(function (d) { return d && d.code && d.pct > 0; })
      .sort(function (a, b) { return b.min - a.min; });

    // ---------- State laden: ?c= (Share-Link) > localStorage > ?goal= ----------
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { params = null; }
    var state = null;
    var fromShare = false;
    var shareInvalid = false;
    if (params && params.get('c')) {
      var decoded = decodeState(params.get('c'));
      shareInvalid = decoded.stale;
      // Unbrauchbare Links NIE übernehmen — sonst landet man mit dem „ungültig“-Hinweis
      // auf einem falschen Ergebnis (z. B. dem alten localStorage-Set). Stattdessen unten
      // auf Schritt 1 zwingen; lokale Antworten bleiben erhalten.
      if (decoded.state && !decoded.stale) { state = decoded.state; fromShare = true; }
    }
    if (!state) state = readPersisted();
    if (!state) state = blankState();
    if (shareInvalid) state.step = 1;
    if (!fromShare && params && params.get('goal') && GOALS.indexOf(params.get('goal')) !== -1) {
      if (state.goals.indexOf(params.get('goal')) === -1) state.goals.unshift(params.get('goal'));
    }
    // Ergebnis nur zeigen, wenn ein Ziel existiert (sonst zurück auf 1).
    if (state.step === 6 && !state.goals.length) state.step = 1;

    var appAvailable = false; // Konfigurator-App (App Proxy) erreichbar? -> E-Mail/Konto-Speichern
    var firstRender = true;

    document.body.classList.add('hm-konf-active');
    mount.innerHTML = '';
    mount.classList.add('hm-konf');

    // Sticky-Topbar unter dem Site-Header andocken. WICHTIG: nicht die statische Höhe
    // spiegeln, sondern die LIVE-Unterkante (rect.bottom) — der Header kann beim Scrollen
    // aus dem Bild laufen oder sich verstecken; die Wizard-Leiste rückt dann an top:0 nach.
    var headerEl = document.querySelector('.site-header');
    var headerSticky = false;
    if (headerEl) {
      var headerPos = window.getComputedStyle(headerEl).position;
      headerSticky = headerPos === 'sticky' || headerPos === 'fixed';
    }
    function syncStickyOffset() {
      var offset = 0;
      if (headerEl && headerSticky) {
        offset = Math.max(0, Math.round(headerEl.getBoundingClientRect().bottom));
      }
      mount.style.setProperty('--hm-konf-top', offset + 'px');
    }
    // Throttle über rAF MIT Timeout-Fallback: in Hintergrund-/Headless-Tabs feuert rAF
    // nicht (zuverlässig) — ohne Fallback bliebe der Offset dann dauerhaft stehen.
    var stickyPending = false;
    function queueStickySync() {
      if (stickyPending) return;
      stickyPending = true;
      function run() {
        if (!stickyPending) return;
        stickyPending = false;
        syncStickyOffset();
      }
      if (window.requestAnimationFrame) window.requestAnimationFrame(run);
      window.setTimeout(run, 120);
    }
    syncStickyOffset();
    window.addEventListener('resize', queueStickySync);
    window.addEventListener('scroll', queueStickySync, { passive: true });
    // Selbstheilung: Header-Geometrie kann sich auch ohne scroll/resize ändern (Promo-Bar,
    // Font-Load, eingebettete Umgebungen ohne Scroll-Events) — niederfrequent nachziehen.
    window.setInterval(syncStickyOffset, 500);

    // ---------- Grundgerüst ----------
    var topbar = el('div', 'hm-konf__topbar');
    var content = el('div', 'hm-konf__content');
    var bottombar = el('div', 'hm-konf__bar');
    mount.appendChild(topbar);
    mount.appendChild(content);
    mount.appendChild(bottombar);

    // Persistenter Screenreader-Announcer: die aria-live-Regionen der Steps werden bei jedem
    // Render neu und bereits befüllt erzeugt (wird nicht angesagt) — Meldungen laufen daher
    // zusätzlich über diese eine stabile Region.
    var announcer = el('div', 'visually-hidden', { role: 'status', 'aria-live': 'polite' });
    mount.appendChild(announcer);
    var announceTimer = 0;
    function announce(msg) {
      window.clearTimeout(announceTimer);
      announcer.textContent = '';
      announceTimer = window.setTimeout(function () { announcer.textContent = msg || ''; }, 60);
    }

    // Re-Render mit Fokus-Erhalt: renderStep() wischt content.innerHTML — ohne Restore landet
    // der Tastatur-Fokus nach jedem Antwort-Klick auf <body>. Jedes Antwort-Element trägt ein
    // stabiles data-key, über das der Fokus nach dem Neuaufbau zurückgesetzt wird.
    function rerender() {
      shareInvalid = false;
      var active = document.activeElement;
      var key = active && content.contains(active) ? active.getAttribute('data-key') : null;
      renderStep();
      renderBar();
      if (key) {
        var esc = window.CSS && CSS.escape ? CSS.escape(key) : key.replace(/"/g, '\\"');
        var node = content.querySelector('[data-key="' + esc + '"]');
        if (node) { try { node.focus({ preventScroll: true }); } catch (e) { node.focus(); } }
      }
    }

    // ---------- Hilfsfunktionen über Daten ----------
    function systemByKey(key) {
      for (var i = 0; i < systems.length; i++) { if (systems[i].key === key) return systems[i]; }
      return null;
    }
    function hubsForSys(key) {
      return allHubs.filter(function (h) { return h.sys === key; });
    }
    function hubByKey(key) {
      for (var i = 0; i < allHubs.length; i++) { if (allHubs[i].key === key) return allHubs[i]; }
      return null;
    }
    function product(handle) { return products[handle] || null; }
    function primaryGoal() { return state.goals[0] || ''; }

    // Verdikt nach Compat-Finder-Logik (assets/compat-finder.js §Spec):
    //   'green' = Thread Border Router vorhanden · 'amber' = Zentrale ohne Thread
    //   'info'  = noch kein System · 'nohub' = System gewählt, aber keine Zentrale
    //   ''      = Schritt 3 unbeantwortet (Express behandelt assumeTbr wie green)
    function verdict() {
      if (state.plat.sys === 'none') return 'info';
      if (!state.plat.sys) return '';
      // Explizite Antworten schlagen die Express-Annahme (assumeTbr ist nur die Brücke
      // für einen unbeantworteten Schritt 3 — auch bei alten Share-/localStorage-States).
      if (state.plat.noHub) return 'nohub';
      var hub = state.plat.hubKey ? hubByKey(state.plat.hubKey) : null;
      if (hub) return hub.thread === true ? 'green' : 'amber';
      return state.plat.assumeTbr ? 'green' : '';
    }

    // ---------- Empfehlungs-Engine ----------
    function computeSetup(override) {
      var goal = primaryGoal();
      var bp = blueprints[goal] || blueprints.start;
      if (!bp) return null;
      var ov = override == null ? state.override : override;

      var scope = state.prefs.scope || 'ausgewogen';
      if (ov === 'cheap') scope = 'kompakt';
      if (ov === 'more') scope = 'komplett';

      // Aufwands-Constraint: Miete/„nur stecken & kleben" -> kein Elektriker; Express ohne
      // Zuhause-Antworten -> konservativ „Schrauben ok" (Elektriker-Geräte nie ungefragt).
      var install = state.home.install || 'screw';
      var noElectric = install !== 'electric' || state.home.tenure === 'miete' || state.goals.indexOf('miete') !== -1;
      var plugOnly = install === 'plug';

      // Raumzahl: die explizite Schritt-2-Angabe („Wie viele Räume möchtest du ausstatten?“)
      // ist der Mengen-Treiber; gewählte Räume aus Schritt 4 können sie nur erhöhen.
      var roomCount = Math.max(
        state.rooms.length,
        state.home.rooms ? RANGE_ROOMS[state.home.rooms] || 0 : 0
      );
      if (roomCount < 1) roomCount = 1;
      // Mengen-Semantik je Item (Blueprint-JSON): per_room = 1 je Raum (Lampen, Thermostate),
      // per_rooms: N = 1 je N Räume (Stecker, Kontakte). Umfang steuert die Reichweite:
      // kompakt = Basismengen · ausgewogen = Kern-Geräte wachsen mit · komplett = alles.
      function scaledQty(it, kind) {
        var q = it.qty || 1;
        if (scope === 'kompakt' || roomCount <= 1) return q;
        if (scope !== 'komplett' && kind !== 'core') return q;
        if (it.per_room) return Math.max(q, roomCount);
        if (it.per_rooms > 0) return Math.max(q, Math.ceil(roomCount / it.per_rooms));
        return q;
      }

      var rows = [];
      var dropped = [];
      function pushRow(handle, qty, role, kind) {
        var p = product(handle);
        // Nicht verfügbare Produkte nie einplanen — ein einziger ausverkaufter Artikel
        // würde sonst den kompletten items[]-Add scheitern lassen (Ajax-API ist atomar).
        if (!p || !p.variant || p.available === false) return false;
        for (var i = 0; i < rows.length; i++) {
          if (rows[i].handle === handle) return true; // dedupe: Add-on nie doppelt zur Item-Liste
        }
        // Mengen auf den Bestand deckeln (gleicher Grund: atomarer Add).
        var capped = qty;
        if (typeof p.stock === 'number') capped = Math.min(capped, p.stock);
        if (capped < 1) { dropped.push(handle); return false; }
        rows.push({ handle: handle, qty: capped, role: role || '', kind: kind || 'core', p: p });
        return true;
      }

      (Array.isArray(bp.items) ? bp.items : []).forEach(function (it) {
        if (!it || !it.product) return;
        if (it.tier === 'plus' && scope === 'kompakt') return;
        var handle = it.product;
        var p = product(handle);
        if (!p) return;
        // Constraint-Check über das Produkt-Facetten-Metafeld install_effort
        if ((noElectric && p.install === 'electric') || (plugOnly && p.install === 'screw')) {
          var alt = it.alt_no_electric ? product(it.alt_no_electric) : null;
          if (alt && !(plugOnly && alt.install === 'screw') && !(noElectric && alt.install === 'electric')) {
            // Beim Swap die Alternativ-Rolle nutzen — die Original-Rolle beschreibt das andere Gerät.
            pushRow(it.alt_no_electric, it.qty || 1, it.alt_role || '', it.tier === 'plus' ? 'plus' : 'core');
          } else {
            dropped.push(handle);
          }
          return;
        }
        var kind = it.tier === 'plus' ? 'plus' : 'core';
        pushRow(handle, scaledQty(it, kind), it.role, kind);
      });

      // Situations-Add-ons: explizite Wünsche aus Schritt 4 (dedupe via pushRow).
      var addons = bp.addons || {};
      if (ov !== 'cheap') {
        state.sits.forEach(function (key) {
          var ad = addons[key];
          if (!ad || !ad.product) return;
          var p = product(ad.product);
          if (!p) return;
          if ((noElectric && p.install === 'electric') || (plugOnly && p.install === 'screw')) return;
          pushRow(ad.product, scaledQty(ad, 'addon'), ad.role, 'addon');
        });
      }

      // Hub-Logik: Thread-Geräte (hub_required) brauchen einen Border Router.
      var v = verdict();
      if (ov === 'nohub') {
        rows = rows.filter(function (r) { return r.p.hubreq !== true; });
      }
      var needsThread = rows.some(function (r) { return r.p.hubreq === true; });
      var hubIncluded = false;
      var hubNeeded = ov !== 'nohub' && needsThread && v !== 'green';
      var hubP = product(data.hubProduct);
      if (hubNeeded && hubP && hubP.variant && hubP.available !== false) {
        hubIncluded = true;
      }

      // Budget-Trimming: nur plus-Tier opfern, nie core/Hub/Add-ons. Ehrlich bleiben.
      var budgetMax = BUDGET_MAX[state.home.budget] || Infinity;
      function total() {
        var sum = rows.reduce(function (acc, r) { return acc + r.p.price * r.qty; }, 0);
        return sum + (hubIncluded ? hubP.price : 0);
      }
      var overBudget = false;
      if (isFinite(budgetMax)) {
        var guard = rows.length;
        while (total() > budgetMax && guard-- > 0) {
          var idx = -1, max = -1;
          for (var i = 0; i < rows.length; i++) {
            if (rows[i].kind !== 'plus') continue;
            var cost = rows[i].p.price * rows[i].qty;
            if (cost > max) { max = cost; idx = i; }
          }
          if (idx === -1) break;
          dropped.push(rows[idx].handle);
          rows.splice(idx, 1);
        }
        overBudget = total() > budgetMax;
      }

      if (!rows.length) return null;

      var sum = total();
      var uvp = rows.reduce(function (acc, r) {
        return acc + (r.p.uvp > r.p.price ? r.p.uvp : r.p.price) * r.qty;
      }, 0) + (hubIncluded ? (hubP.uvp > hubP.price ? hubP.uvp : hubP.price) : 0);

      // Ehrliche Claims: Matter-/Multi-Admin-/Lokal-Aussagen nur, wenn ALLE Geräte im Set
      // Matter/Thread sprechen (WLAN-only-Geräte wie die Innenkamera brechen die Pauschale).
      // Produkte ohne protocols-Facette (z. B. passive NFC-Tags) zählen neutral.
      function matterReady(p) {
        if (!p || !Array.isArray(p.protocols) || !p.protocols.length) return true;
        return p.protocols.indexOf('matter') !== -1 || p.protocols.indexOf('thread') !== -1;
      }
      var allMatter = rows.every(function (r) { return matterReady(r.p); });

      return {
        goal: goal, bp: bp, rows: rows, verdict: v,
        hubIncluded: hubIncluded, hub: hubIncluded ? hubP : null,
        hubMissing: hubNeeded && !hubIncluded, hubName: hubP ? hubP.name : '',
        allMatter: allMatter, roomCount: roomCount,
        total: sum, uvp: uvp > sum ? uvp : 0,
        overBudget: overBudget, dropped: dropped, scope: scope, override: ov
      };
    }

    function discountFor(totalCents) {
      for (var i = 0; i < discounts.length; i++) {
        if (totalCents >= discounts[i].min) return discounts[i];
      }
      return null;
    }
    function nextDiscount(totalCents) {
      var best = null;
      for (var i = 0; i < discounts.length; i++) {
        if (totalCents < discounts[i].min && (!best || discounts[i].min < best.min)) best = discounts[i];
      }
      return best;
    }

    // ---------- Validierung ----------
    function stepError() {
      var s = state;
      switch (s.step) {
        case 1:
          if (!s.goals.length) return S.e_goal;
          return '';
        case 2:
          if (!s.home.form) return S.e_form;
          if (!s.home.tenure) return S.e_tenure;
          if (!s.home.install) return S.e_install;
          if (!s.home.budget) return S.e_budget;
          return '';
        case 3:
          if (!s.plat.sys) return S.e_platform;
          if (s.plat.sys !== 'none' && !s.plat.assumeTbr && !s.plat.noHub && !s.plat.hubKey) return S.e_hub;
          return '';
        case 4:
          if (!s.sits.length) return S.e_situation;
          return '';
        case 5:
          if (!s.prefs.scope) return S.e_scope;
          return '';
      }
      return '';
    }

    // ---------- Navigation ----------
    var errorNow = ''; // wird erst nach „Weiter"-Klick gezeigt, nicht beim Tippen

    function goto(step, focusHeading) {
      shareInvalid = false;
      state.step = step;
      state.override = step === 6 ? state.override : '';
      errorNow = '';
      persist(state);
      emit('konfigurator:step', { step: step });
      render(focusHeading !== false);
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
    function tryNext() {
      var err = stepError();
      if (err) {
        errorNow = err;
        renderBar();
        announce(err);
        return;
      }
      goto(state.step + 1);
    }

    // ============================ RENDERING ============================

    function render(focusHeading) {
      renderTopbar();
      renderStep();
      renderBar();
      // Abfang-Hinweis für unbrauchbare Share-Links: freundlich erklären, frisch starten lassen.
      // Verschwindet mit der ersten eigenen Interaktion (rerender/goto setzen das Flag zurück).
      if (shareInvalid) {
        var shareNote = el('p', 'hm-konf__hint hm-konf__hint--warn hm-konf__sharenote');
        shareNote.innerHTML = svg('info', 16) + '<span></span>';
        shareNote.querySelector('span').textContent = S.share_invalid;
        content.insertBefore(shareNote, content.firstChild);
      }
      if (focusHeading && !firstRender) {
        var h = content.querySelector('.hm-konf__h1');
        if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
      }
      firstRender = false;
    }

    // ---------- Topbar: Stepper (Desktop) / Fortschrittsbalken (Mobile) + Speichern ----------
    function renderTopbar() {
      topbar.innerHTML = '';
      var labels = [S.s1, S.s2, S.s3, S.s4, S.s5, S.s6];

      var row = el('div', 'hm-konf__toprow');
      // Mobile-Kopf: aktuelles Label + „Schritt n / 6"
      var mhead = el('div', 'hm-konf__mhead');
      mhead.appendChild(txt('span', 'hm-konf__mlabel', labels[state.step - 1]));
      mhead.appendChild(txt('span', 'hm-konf__mcount', interpolate(S.step_of, { n: state.step })));
      row.appendChild(mhead);

      // Desktop-Stepper (nur rückwärts klickbar)
      var stepper = el('div', 'hm-konf__stepper', { role: 'group', 'aria-label': S.progress_label });
      for (var n = 1; n <= 6; n++) {
        var done = n < state.step;
        var current = n === state.step;
        var node = el(done ? 'button' : 'div', 'hm-konf__snode' + (done ? ' is-done' : '') + (current ? ' is-current' : ''));
        if (done) {
          node.setAttribute('type', 'button');
          (function (target) {
            node.addEventListener('click', function () { goto(target); });
          })(n);
        }
        if (current) node.setAttribute('aria-current', 'step');
        var dot = el('span', 'hm-konf__sdot');
        if (done) dot.innerHTML = svg('check', 14); else dot.textContent = String(n);
        var lbl = el('span', 'hm-konf__slbl');
        lbl.appendChild(txt('span', 'hm-konf__skick', interpolate(S.step_label, { n: n })));
        lbl.appendChild(txt('span', 'hm-konf__sname', labels[n - 1]));
        node.appendChild(dot);
        node.appendChild(lbl);
        stepper.appendChild(node);
      }
      row.appendChild(stepper);

      // Speichern (Desktop: Text-Pill, Mobile: Icon)
      var save = el('button', 'hm-konf__save', { type: 'button', 'aria-label': S.save });
      save.innerHTML = svg('save', 16) + '<span></span>';
      save.querySelector('span').textContent = S.save;
      save.addEventListener('click', function () { saveConfig(save); });
      row.appendChild(save);
      topbar.appendChild(row);

      // Mobile-Fortschrittsbalken (6 Segmente)
      var prog = el('div', 'hm-konf__prog', { role: 'progressbar', 'aria-valuemin': '1', 'aria-valuemax': '6', 'aria-valuenow': String(state.step), 'aria-label': S.progress_label });
      for (var i = 1; i <= 6; i++) {
        prog.appendChild(el('span', 'hm-konf__pseg' + (i <= state.step ? ' is-on' : '')));
      }
      topbar.appendChild(prog);
    }

    // ---------- Auswahl-Bausteine ----------
    function chip(label, pressed, onToggle, cls) {
      var c = el('button', 'hm-konf__chip' + (cls ? ' ' + cls : ''), { type: 'button', 'aria-pressed': pressed ? 'true' : 'false', 'data-key': 'chip:' + label });
      c.textContent = label;
      c.addEventListener('click', onToggle);
      return c;
    }
    function bigChip(title, sub, pressed, onToggle) {
      var c = el('button', 'hm-konf__chip hm-konf__chip--2l', { type: 'button', 'aria-pressed': pressed ? 'true' : 'false', 'data-key': 'chip:' + title });
      c.appendChild(txt('span', 'hm-konf__chip-t', title));
      if (sub) c.appendChild(txt('span', 'hm-konf__chip-s', sub));
      c.addEventListener('click', onToggle);
      return c;
    }
    function head(kicker, title, sub) {
      var wrap = el('header', 'hm-konf__head');
      if (kicker) wrap.appendChild(txt('p', 'hm-konf__kicker', kicker));
      wrap.appendChild(txt('h2', 'hm-konf__h1', title));
      if (sub) wrap.appendChild(txt('p', 'hm-konf__sub', sub));
      return wrap;
    }
    function qBlock(card, label, hint) {
      var block = el('div', 'hm-konf__q');
      block.appendChild(txt('p', 'hm-konf__q-label', label));
      if (hint) block.appendChild(txt('p', 'hm-konf__q-hint', hint));
      card.appendChild(block);
      return block;
    }
    function toggleAll(arr, value) {
      var i = arr.indexOf(value);
      if (i === -1) arr.push(value); else arr.splice(i, 1);
    }

    function renderStep() {
      content.innerHTML = '';
      switch (state.step) {
        case 1: return renderStep1();
        case 2: return renderStep2();
        case 3: return renderStep3();
        case 4: return renderStep4();
        case 5: return renderStep5();
        case 6: return renderStep6();
      }
    }

    // ---------- Schritt 1: Ziel & Alltag ----------
    function renderStep1() {
      var wrap = el('div', 'hm-konf__step hm-konf__step--center');
      wrap.appendChild(head(S.s1_kicker, S.s1_title, S.s1_sub));

      // Express-Einstieg
      var express = el('button', 'hm-konf__express', { type: 'button' });
      express.innerHTML = svg('bolt', 15) + '<span></span>';
      express.querySelector('span').textContent = S.express_pill;
      express.addEventListener('click', openExpress);
      wrap.appendChild(express);

      // Ehrliche Trust-Zeile (keine erfundenen Zahlen — Rechtsprüfung 2026-07)
      var trust = el('p', 'hm-konf__trust');
      trust.innerHTML = svg('shield', 14) + '<span></span>';
      trust.querySelector('span').textContent = S.s1_trust;
      wrap.appendChild(trust);

      var grid = el('div', 'hm-konf__goals', { role: 'group', 'aria-label': S.s1_title });
      GOALS.forEach(function (g) {
        var pressed = state.goals.indexOf(g) !== -1;
        var card = el('button', 'hm-konf__goal', { type: 'button', 'aria-pressed': pressed ? 'true' : 'false', 'data-key': 'goal:' + g });
        var ico = el('span', 'hm-konf__goal-ico');
        ico.innerHTML = svg(GOAL_ICON[g], 24);
        var body = el('span', 'hm-konf__goal-body');
        body.appendChild(txt('span', 'hm-konf__goal-t', S['goal_' + g]));
        body.appendChild(txt('span', 'hm-konf__goal-s', S['goal_' + g + '_sub']));
        var mark = el('span', 'hm-konf__goal-check');
        mark.innerHTML = svg('check', 14);
        card.appendChild(ico);
        card.appendChild(body);
        card.appendChild(mark);
        card.addEventListener('click', function () {
          toggleAll(state.goals, g);
          errorNow = '';
          persist(state);
          rerender();
        });
        grid.appendChild(card);
      });
      wrap.appendChild(grid);
      content.appendChild(wrap);
    }

    // ---------- Schritt 2: Dein Zuhause ----------
    function renderStep2() {
      var wrap = el('div', 'hm-konf__step');
      wrap.appendChild(head(S.s2_kicker, S.s2_title, S.s2_sub));
      var card = el('div', 'hm-konf__card');

      var qForm = qBlock(card, S.s2_q_form);
      var rowForm = el('div', 'hm-konf__chips');
      [['wohnung', S.s2_wohnung], ['haus', S.s2_haus]].forEach(function (o) {
        rowForm.appendChild(chip(o[1], state.home.form === o[0], function () {
          state.home.form = o[0]; errorNow = ''; persist(state); rerender();
        }));
      });
      qForm.appendChild(rowForm);

      var qTen = qBlock(card, S.s2_q_tenure);
      var rowTen = el('div', 'hm-konf__chips');
      [['miete', S.s2_miete], ['eigentum', S.s2_eigentum]].forEach(function (o) {
        rowTen.appendChild(chip(o[1], state.home.tenure === o[0], function () {
          state.home.tenure = o[0]; errorNow = ''; persist(state); rerender();
        }));
      });
      qTen.appendChild(rowTen);
      if (state.home.tenure === 'miete') {
        var hint = el('p', 'hm-konf__hint hm-konf__hint--info');
        hint.innerHTML = svg('info', 16) + '<span></span>';
        hint.querySelector('span').textContent = S.s2_hint_miete;
        qTen.appendChild(hint);
      }

      var qRooms = qBlock(card, S.s2_q_rooms, S.s2_q_rooms_hint);
      var rowRooms = el('div', 'hm-konf__chips');
      [['r1', S.s2_r1], ['r2', S.s2_r2], ['r3', S.s2_r3], ['r4', S.s2_r4]].forEach(function (o) {
        rowRooms.appendChild(chip(o[1], state.home.rooms === o[0], function () {
          state.home.rooms = state.home.rooms === o[0] ? '' : o[0];
          persist(state); rerender();
        }));
      });
      qRooms.appendChild(rowRooms);

      var qInst = qBlock(card, S.s2_q_install, S.s2_q_install_hint);
      var rowInst = el('div', 'hm-konf__chips hm-konf__chips--stack');
      [['plug', S.s2_plug, S.s2_plug_sub], ['screw', S.s2_screw, S.s2_screw_sub], ['electric', S.s2_electric, S.s2_electric_sub]].forEach(function (o) {
        rowInst.appendChild(bigChip(o[1], o[2], state.home.install === o[0], function () {
          state.home.install = o[0]; errorNow = ''; persist(state); rerender();
        }));
      });
      qInst.appendChild(rowInst);

      var qBud = qBlock(card, S.s2_q_budget);
      var rowBud = el('div', 'hm-konf__chips');
      [['b1', S.s2_b1], ['b2', S.s2_b2], ['b3', S.s2_b3], ['b4', S.s2_b4]].forEach(function (o) {
        rowBud.appendChild(chip(o[1], state.home.budget === o[0], function () {
          state.home.budget = o[0]; errorNow = ''; persist(state); rerender();
        }));
      });
      qBud.appendChild(rowBud);
      qBud.appendChild(txt('p', 'hm-konf__foot', S.s2_budget_foot));

      wrap.appendChild(card);
      content.appendChild(wrap);
    }

    // ---------- Schritt 3: Plattform & Technik (Compat-Logik) ----------
    function renderStep3() {
      var wrap = el('div', 'hm-konf__step');
      wrap.appendChild(head(S.s3_kicker, S.s3_title, S.s3_sub));

      // Frage A: System (aus dem geteilten Compat-Datentopf, inkl. „Noch nichts")
      var sysWrap = el('div', 'hm-konf__q');
      sysWrap.appendChild(txt('p', 'hm-konf__q-label', S.s3_q_sys));
      var sysRow = el('div', 'hm-konf__sys', { role: 'group', 'aria-label': S.s3_q_sys });
      systems.forEach(function (sy) {
        var pressed = state.plat.sys === sy.key;
        var card = el('button', 'hm-konf__syscard', { type: 'button', 'aria-pressed': pressed ? 'true' : 'false', 'data-sys': sy.key, 'data-key': 'sys:' + sy.key });
        var badge = el('span', 'hm-konf__sysbadge');
        badge.style.background = sy.bg || 'var(--color-border-light)';
        badge.style.color = sy.fg || 'var(--accent)';
        badge.textContent = sy.mark || (sy.name || '?').charAt(0);
        card.appendChild(badge);
        card.appendChild(txt('span', 'hm-konf__syslabel', sy.name));
        card.addEventListener('click', function () {
          state.plat.sys = sy.key;
          state.plat.hubKey = '';
          state.plat.noHub = false;
          state.plat.assumeTbr = false;
          var xi = state.plat.extras.indexOf(sy.key);
          if (xi !== -1) state.plat.extras.splice(xi, 1);
          errorNow = '';
          persist(state);
          emit('konfigurator:select_ecosystem', { system: sy.name, system_key: sy.key });
          rerender();
        });
        sysRow.appendChild(card);
      });
      sysWrap.appendChild(sysRow);
      wrap.appendChild(sysWrap);

      var sys = state.plat.sys ? systemByKey(state.plat.sys) : null;

      // Frage B: Zentrale — Hub-Liste des Systems (Compat-Finder-Verhalten) + „Noch keine"
      if (sys && sys.key !== 'none') {
        var hubs = hubsForSys(sys.key);
        var hubWrap = el('div', 'hm-konf__q hm-konf__fade');
        var extra = data.systemsExtra && data.systemsExtra[sys.key];
        var hubQ = extra && typeof extra.hubq === 'string' && extra.hubq ? extra.hubq : interpolate(S.s3_q_hub, { system: sys.name });
        hubWrap.appendChild(txt('p', 'hm-konf__q-label', hubQ));
        hubWrap.appendChild(txt('p', 'hm-konf__q-hint', S.s3_hub_hint));

        var grid = el('div', 'hm-konf__hubs', { role: 'group', 'aria-label': hubQ });
        hubs.forEach(function (hub) {
          var selected = state.plat.hubKey === hub.key;
          var card = el('button', 'hm-konf__hubcard', { type: 'button', 'aria-pressed': selected ? 'true' : 'false', 'data-key': 'hub:' + hub.key });
          if (selected) card.setAttribute('data-sel', hub.thread === true ? 'green' : 'amber');
          var ico = el('span', 'hm-konf__hubico');
          if (hub.img) {
            ico.classList.add('hm-konf__hubico--img');
            ico.appendChild(el('img', 'hm-konf__hubimg', { src: hub.img, alt: '', loading: 'lazy', width: '42', height: '42' }));
          } else {
            ico.innerHTML = svg('hub', 20);
          }
          var body = el('span', 'hm-konf__hubbody');
          body.appendChild(txt('span', 'hm-konf__hubname', hub.name));
          if (hub.model) body.appendChild(txt('span', 'hm-konf__hubmodel', hub.model));
          var chipEl = el('span', 'hm-konf__hchip ' + (hub.thread === true ? 'hm-konf__hchip--ok' : 'hm-konf__hchip--no'));
          chipEl.textContent = hub.thread === true ? S.s3_chip_thread : S.s3_chip_nothread;
          body.appendChild(chipEl);
          card.appendChild(ico);
          card.appendChild(body);
          card.addEventListener('click', function () {
            state.plat.hubKey = hub.key;
            state.plat.noHub = false;
            state.plat.assumeTbr = false;
            errorNow = '';
            persist(state);
            rerender();
          });
          grid.appendChild(card);
        });
        // „Nein, noch keine Zentrale"
        var none = el('button', 'hm-konf__hubcard hm-konf__hubcard--none', { type: 'button', 'aria-pressed': state.plat.noHub ? 'true' : 'false', 'data-key': 'hub:none' });
        if (state.plat.noHub) none.setAttribute('data-sel', 'info');
        var nIco = el('span', 'hm-konf__hubico');
        nIco.innerHTML = svg('info', 20);
        var nBody = el('span', 'hm-konf__hubbody');
        nBody.appendChild(txt('span', 'hm-konf__hubname', S.s3_hub_none));
        nBody.appendChild(txt('span', 'hm-konf__hubmodel', S.s3_hub_none_sub));
        none.appendChild(nIco);
        none.appendChild(nBody);
        none.addEventListener('click', function () {
          state.plat.noHub = true;
          state.plat.hubKey = '';
          state.plat.assumeTbr = false;
          errorNow = '';
          persist(state);
          rerender();
        });
        grid.appendChild(none);
        hubWrap.appendChild(grid);
        wrap.appendChild(hubWrap);
      }

      // Verdikt-/Infra-Hinweis (Logik + Ton des Compat-Finders)
      var v = verdict();
      if (v) {
        var tone = v === 'green' ? 'ok' : v === 'amber' ? 'warn' : 'info';
        var vHint = el('p', 'hm-konf__hint hm-konf__hint--' + tone + ' hm-konf__fade', { role: 'status' });
        vHint.innerHTML = svg(v === 'green' ? 'check' : v === 'amber' ? 'warn' : 'info', 16) + '<span></span>';
        var hub = state.plat.hubKey ? hubByKey(state.plat.hubKey) : null;
        var hubP = product(data.hubProduct);
        var vars = { hub: hub ? hub.name : '', rec: hubP ? hubP.name : '', system: sys ? sys.name : '' };
        var msg = '';
        if (v === 'green') msg = state.plat.assumeTbr && !hub ? S.r_hub_assumed : interpolate(S.s3_v_green, vars);
        else if (v === 'amber') msg = interpolate(S.s3_v_amber, vars);
        else if (v === 'nohub') msg = interpolate(S.s3_v_nohub, vars);
        else {
          var extraNone = data.systemsExtra && data.systemsExtra.none;
          msg = extraNone && typeof extraNone.infra === 'string' && extraNone.infra ? extraNone.infra : interpolate(S.s3_v_none, vars);
        }
        vHint.querySelector('span').textContent = msg;
        wrap.appendChild(vHint);
      }

      // Frage C: Zusatz-Apps (optional, Matter Multi-Admin)
      if (sys && (v === 'green' || v === 'amber' || v === 'nohub')) {
        var appsWrap = el('div', 'hm-konf__q hm-konf__fade');
        var lblRow = el('p', 'hm-konf__q-label');
        lblRow.textContent = S.s3_q_apps + ' ';
        lblRow.appendChild(txt('span', 'hm-konf__optional', S.optional));
        appsWrap.appendChild(lblRow);
        appsWrap.appendChild(txt('p', 'hm-konf__q-hint', S.s3_apps_hint));
        var appsRow = el('div', 'hm-konf__chips');
        systems.forEach(function (sy) {
          if (sy.key === 'none' || sy.key === state.plat.sys) return;
          appsRow.appendChild(chip(sy.name, state.plat.extras.indexOf(sy.key) !== -1, function () {
            toggleAll(state.plat.extras, sy.key);
            persist(state); rerender();
          }));
        });
        appsWrap.appendChild(appsRow);
        wrap.appendChild(appsWrap);
      }

      content.appendChild(wrap);
    }

    // ---------- Schritt 4: Räume & Situationen ----------
    function renderStep4() {
      var wrap = el('div', 'hm-konf__step');
      wrap.appendChild(head(S.s4_kicker, S.s4_title, S.s4_sub));

      var qRooms = el('div', 'hm-konf__q');
      var lblRow = el('p', 'hm-konf__q-label');
      lblRow.textContent = S.s4_q_rooms + ' ';
      lblRow.appendChild(txt('span', 'hm-konf__optional', S.optional));
      qRooms.appendChild(lblRow);
      var rowRooms = el('div', 'hm-konf__chips');
      ROOMS.forEach(function (r) {
        rowRooms.appendChild(chip(S['room_' + r], state.rooms.indexOf(r) !== -1, function () {
          toggleAll(state.rooms, r);
          persist(state); rerender();
        }));
      });
      qRooms.appendChild(rowRooms);
      wrap.appendChild(qRooms);

      var qSits = el('div', 'hm-konf__q');
      qSits.appendChild(txt('p', 'hm-konf__q-label', S.s4_q_sits));
      var grid = el('div', 'hm-konf__goals hm-konf__goals--sits', { role: 'group', 'aria-label': S.s4_q_sits });
      SITS.forEach(function (key) {
        var pressed = state.sits.indexOf(key) !== -1;
        var card = el('button', 'hm-konf__goal', { type: 'button', 'aria-pressed': pressed ? 'true' : 'false', 'data-key': 'sit:' + key });
        var ico = el('span', 'hm-konf__goal-ico');
        ico.innerHTML = svg(SIT_ICON[key], 22);
        var body = el('span', 'hm-konf__goal-body');
        body.appendChild(txt('span', 'hm-konf__goal-t', S['sit_' + key]));
        body.appendChild(txt('span', 'hm-konf__goal-s', S['sit_' + key + '_sub']));
        var mark = el('span', 'hm-konf__goal-check');
        mark.innerHTML = svg('check', 14);
        card.appendChild(ico);
        card.appendChild(body);
        card.appendChild(mark);
        card.addEventListener('click', function () {
          toggleAll(state.sits, key);
          errorNow = '';
          persist(state); rerender();
        });
        grid.appendChild(card);
      });
      qSits.appendChild(grid);
      wrap.appendChild(qSits);
      content.appendChild(wrap);
    }

    // ---------- Schritt 5: Prioritäten (entdoppelt: Umfang + 2 Schalter) ----------
    function renderStep5() {
      var wrap = el('div', 'hm-konf__step');
      wrap.appendChild(head(S.s5_kicker, S.s5_title, S.s5_sub));
      var card = el('div', 'hm-konf__card');

      var qScope = qBlock(card, S.s5_q_scope, S.s5_q_scope_hint);
      var rowScope = el('div', 'hm-konf__chips hm-konf__chips--stack');
      [['kompakt', S.s5_kompakt, S.s5_kompakt_sub], ['ausgewogen', S.s5_ausgewogen, S.s5_ausgewogen_sub], ['komplett', S.s5_komplett, S.s5_komplett_sub]].forEach(function (o) {
        var c = bigChip(o[1], o[2], state.prefs.scope === o[0], function () {
          state.prefs.scope = o[0]; errorNow = ''; persist(state); rerender();
        });
        if (o[0] === 'ausgewogen') {
          c.appendChild(txt('span', 'hm-konf__reco', S.s5_reco));
        }
        rowScope.appendChild(c);
      });
      qScope.appendChild(rowScope);

      function toggleRow(block, key, title, sub, consequence) {
        var row = el('div', 'hm-konf__toggle');
        var lbl = el('span', 'hm-konf__toggle-lbl');
        lbl.appendChild(txt('span', 'hm-konf__toggle-t', title));
        lbl.appendChild(txt('span', 'hm-konf__toggle-s', sub));
        var sw = el('button', 'hm-konf__switch', { type: 'button', role: 'switch', 'aria-checked': state.prefs[key] ? 'true' : 'false', 'aria-label': title, 'data-key': 'switch:' + key });
        sw.appendChild(el('span', 'hm-konf__knob'));
        sw.addEventListener('click', function () {
          state.prefs[key] = !state.prefs[key];
          persist(state); rerender();
        });
        row.appendChild(lbl);
        row.appendChild(sw);
        block.appendChild(row);
        if (state.prefs[key]) {
          var hint = el('p', 'hm-konf__hint hm-konf__hint--info hm-konf__fade');
          hint.innerHTML = svg('check', 15) + '<span></span>';
          hint.querySelector('span').textContent = consequence;
          block.appendChild(hint);
        }
      }
      var qTog = qBlock(card, S.s5_q_prefs);
      toggleRow(qTog, 'local', S.s5_local, S.s5_local_sub, S.s5_local_msg);
      toggleRow(qTog, 'fewApps', S.s5_apps, S.s5_apps_sub, S.s5_apps_msg);

      wrap.appendChild(card);
      content.appendChild(wrap);
    }

    // ---------- Schritt 6: Ergebnis ----------
    function renderStep6() {
      var setup = computeSetup();
      var wrap = el('div', 'hm-konf__step hm-konf__step--wide');

      if (!setup) {
        var empty = el('div', 'hm-konf__card hm-konf__empty');
        empty.appendChild(txt('p', '', S.result_empty));
        var back = el('button', 'hm-konf__btn hm-konf__btn--dark', { type: 'button' });
        back.textContent = S.back;
        back.addEventListener('click', function () { goto(1); });
        empty.appendChild(back);
        wrap.appendChild(empty);
        content.appendChild(wrap);
        return;
      }

      // Ergebnis-Event nur bei inhaltlich neuem Setup (Re-Renders nicht doppelt zählen).
      var sig = setup.goal + '|' + setup.total + '|' + setup.verdict + '|' + setup.override;
      if (mount.__lastResultSig !== sig) {
        mount.__lastResultSig = sig;
        emit('konfigurator:result', { goal: setup.goal, total: setup.total, verdict: setup.verdict, items: setup.rows.length });
      }

      // Kopf
      var headWrap = el('header', 'hm-konf__head hm-konf__head--center');
      var badge = el('p', 'hm-konf__done');
      badge.innerHTML = svg('check', 14) + '<span></span>';
      badge.querySelector('span').textContent = S.s6_badge;
      headWrap.appendChild(badge);
      headWrap.appendChild(txt('h2', 'hm-konf__h1', S.s6_title));
      headWrap.appendChild(txt('p', 'hm-konf__sub', S.s6_sub));
      wrap.appendChild(headWrap);

      var grid = el('div', 'hm-konf__result');

      // ---- Hauptkarte ----
      var main = el('article', 'hm-konf__main');
      var mHead = el('div', 'hm-konf__main-head');
      var mHeadCopy = el('div', 'hm-konf__main-headcopy');
      mHeadCopy.appendChild(txt('p', 'hm-konf__main-kicker', S.s6_box_kicker));
      mHeadCopy.appendChild(txt('h3', 'hm-konf__main-title', setup.bp.label || ''));
      if (setup.bp.subline) mHeadCopy.appendChild(txt('p', 'hm-konf__main-sub', setup.bp.subline));
      var mPrice = el('div', 'hm-konf__main-price');
      if (setup.uvp) {
        mPrice.appendChild(txt('s', 'hm-konf__uvp', interpolate(S.s6_uvp, { amount: money(setup.uvp) })));
      }
      mPrice.appendChild(txt('strong', 'hm-konf__total', money(setup.total)));
      mHead.appendChild(mHeadCopy);
      mHead.appendChild(mPrice);
      main.appendChild(mHead);

      var mBody = el('div', 'hm-konf__main-body');

      // Warum das zu dir passt
      mBody.appendChild(txt('p', 'hm-konf__seclabel', S.s6_why));
      var whyList = el('ul', 'hm-konf__why');
      buildReasons(setup).forEach(function (r) {
        var li = el('li', 'hm-konf__why-row');
        li.innerHTML = svg('check', 15) + '<span></span>';
        li.querySelector('span').textContent = r;
        whyList.appendChild(li);
      });
      mBody.appendChild(whyList);

      // Das ist enthalten
      mBody.appendChild(txt('p', 'hm-konf__seclabel', S.s6_contains));
      var list = el('ul', 'hm-konf__items');
      setup.rows.forEach(function (r) { list.appendChild(itemRow(r.p, r.qty, r.role, false)); });
      if (setup.hubIncluded) list.appendChild(itemRow(setup.hub, 1, S.s6_hub_role, true));
      mBody.appendChild(list);

      // Rabatt-Hinweis (ehrlich: Code + Bedingung transparent)
      var disc = discountFor(setup.total);
      var nextD = nextDiscount(setup.total);
      if (disc) {
        var dHint = el('p', 'hm-konf__hint hm-konf__hint--ok');
        dHint.innerHTML = svg('check', 15) + '<span></span>';
        dHint.querySelector('span').textContent = interpolate(S.s6_discount_active, {
          pct: disc.pct, code: disc.code, saving: money(Math.round(setup.total * disc.pct / 100))
        });
        mBody.appendChild(dHint);
      } else if (nextD) {
        var nHint = el('p', 'hm-konf__hint hm-konf__hint--info');
        nHint.innerHTML = svg('info', 15) + '<span></span>';
        nHint.querySelector('span').textContent = interpolate(S.s6_discount_hint, {
          pct: nextD.pct, code: nextD.code, min: money(nextD.min)
        });
        mBody.appendChild(nHint);
      }
      if (setup.overBudget) {
        var bHint = el('p', 'hm-konf__hint hm-konf__hint--warn');
        bHint.innerHTML = svg('info', 15) + '<span></span>';
        bHint.querySelector('span').textContent = S.s6_over_budget + (setup.hubIncluded ? ' ' + S.s6_over_budget_hub : '');
        mBody.appendChild(bHint);
      }
      if (setup.hubMissing) {
        var hHint = el('p', 'hm-konf__hint hm-konf__hint--warn');
        hHint.innerHTML = svg('warn', 15) + '<span></span>';
        hHint.querySelector('span').textContent = interpolate(S.s6_hub_oos, { hub: setup.hubName });
        mBody.appendChild(hHint);
      }

      // CTA
      var cta = el('button', 'hm-konf__btn hm-konf__btn--accent hm-konf__cta', { type: 'button' });
      cta.innerHTML = svg('cart', 18) + '<span></span>';
      cta.querySelector('span').textContent = interpolate(S.s6_cta, { total: money(setup.total) });
      cta.addEventListener('click', function () { addSetupToCart(setup, cta); });
      mBody.appendChild(cta);
      var ctaNote = el('p', 'hm-konf__cta-note', { role: 'status', 'aria-live': 'polite' });
      mBody.appendChild(ctaNote);

      main.appendChild(mBody);
      grid.appendChild(main);

      // ---- Sidebar ----
      var side = el('div', 'hm-konf__side');
      side.appendChild(compatCard(setup));
      side.appendChild(techCard(setup));
      side.appendChild(saveCard(setup));
      grid.appendChild(side);
      wrap.appendChild(grid);

      // ---- Automationen + Roadmap ----
      var duo = el('div', 'hm-konf__duo');
      duo.appendChild(autosCard(setup));
      var rm = roadmapCard(setup);
      if (rm) duo.appendChild(rm);
      wrap.appendChild(duo);

      // ---- Alternativen ----
      var alts = altsRow(setup);
      if (alts) wrap.appendChild(alts);

      // ---- Neustart ----
      var restart = el('button', 'hm-konf__restart', { type: 'button' });
      restart.innerHTML = svg('restart', 15) + '<span></span>';
      restart.querySelector('span').textContent = S.restart;
      restart.addEventListener('click', function () {
        state = blankState();
        try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
        goto(1);
      });
      wrap.appendChild(restart);

      content.appendChild(wrap);
    }

    function itemRow(p, qty, role, isBase) {
      var li = el('li', 'hm-konf__item' + (isBase ? ' hm-konf__item--base' : ''));
      var media = el('a', 'hm-konf__item-media', { href: p.url, tabindex: '-1', 'aria-hidden': 'true' });
      if (p.img) media.appendChild(el('img', '', { src: p.img, alt: '', loading: 'lazy', width: '46', height: '46' }));
      else media.innerHTML = svg('hub', 20);
      var body = el('div', 'hm-konf__item-body');
      var nameRow = el('div', 'hm-konf__item-namerow');
      var link = el('a', 'hm-konf__item-name', { href: p.url });
      link.textContent = p.name || p.title;
      nameRow.appendChild(link);
      if (isBase) nameRow.appendChild(txt('span', 'hm-konf__item-badge', S.s6_hub_badge));
      body.appendChild(nameRow);
      if (role) body.appendChild(txt('p', 'hm-konf__item-role', role));
      var priceCol = el('div', 'hm-konf__item-price');
      priceCol.appendChild(txt('span', 'hm-konf__item-qty', interpolate(S.s6_qty, { n: qty })));
      priceCol.appendChild(txt('span', 'hm-konf__item-sum', money(p.price * qty)));
      li.appendChild(media);
      li.appendChild(body);
      li.appendChild(priceCol);
      return li;
    }

    function buildReasons(setup) {
      var out = [];
      var goalReason = S['r_goal_' + setup.goal];
      if (goalReason) out.push(goalReason);
      var hub = state.plat.hubKey ? hubByKey(state.plat.hubKey) : null;
      if (setup.verdict === 'green' && hub) out.push(interpolate(S.r_hub_green, { hub: hub.name }));
      else if (setup.verdict === 'green' && state.plat.assumeTbr) out.push(S.r_hub_assumed);
      else if (setup.hubIncluded) out.push(interpolate(S.r_hub_incl, { hub: setup.hub.name }));
      else if (setup.verdict === 'amber' && hub) out.push(interpolate(S.r_hub_amber, { hub: hub.name }));
      var noElectric = state.home.tenure === 'miete' || state.goals.indexOf('miete') !== -1 || state.home.install === 'plug';
      if (noElectric) out.push(S.r_norent);
      if (state.rooms.length) {
        var names = state.rooms.map(function (r) { return S['room_' + r]; });
        out.push(interpolate(S.r_rooms, { rooms: names.join(', ') }));
      } else if (setup.roomCount > 1) {
        out.push(interpolate(S.r_rooms_count, { n: setup.roomCount }));
      }
      if (state.prefs.local) out.push(setup.allMatter ? S.r_local : S.r_local_mixed);
      if (state.prefs.fewApps) out.push(setup.allMatter ? S.r_apps : S.r_apps_mixed);
      if (state.home.budget && !setup.overBudget) out.push(S.r_budget_fit);
      if (out.length < 3) out.push(S.r_fallback);
      return out.slice(0, 5);
    }

    function compatCard(setup) {
      var card = el('article', 'hm-konf__dark');
      var label = el('p', 'hm-konf__dark-label');
      label.innerHTML = svg('shield', 16) + '<span></span>';
      label.querySelector('span').textContent = S.s6_comp;
      card.appendChild(label);
      var sys = state.plat.sys && state.plat.sys !== 'none' ? systemByKey(state.plat.sys) : null;
      var line;
      if (!sys) {
        // Ohne enthaltene Zentrale nie "Startklar mit der X" behaupten (nohub-Alternative,
        // ausverkaufte Zentrale).
        line = setup.hubIncluded
          ? interpolate(S.s6_comp_none, { hub: setup.hub.name })
          : S.s6_comp_none_nohub;
      } else if (state.plat.extras.length) {
        var extraNames = state.plat.extras.map(function (k) { var s = systemByKey(k); return s ? s.name : k; });
        line = interpolate(S.s6_comp_multi, { system: sys.name, extras: extraNames.join(', ') });
      } else line = interpolate(S.s6_comp_platform, { system: sys.name });
      card.appendChild(txt('p', 'hm-konf__dark-text', line));
      var badges = el('div', 'hm-konf__dark-badges');
      var remoteBadge;
      if (setup.hubIncluded || setup.hubMissing) remoteBadge = S.s6_b_remote_hub;
      else if (setup.verdict === 'green') remoteBadge = S.s6_b_remote_own;
      else remoteBadge = S.s6_b_remote_app;
      // Matter-/Multi-Admin-Badges nur, wenn wirklich ALLE Geräte im Set Matter/Thread sprechen.
      [S.s6_b_local, remoteBadge, setup.allMatter ? S.s6_b_matter : '', setup.allMatter ? S.s6_b_multiadmin : ''].forEach(function (b) {
        if (b) badges.appendChild(txt('span', 'hm-konf__dark-badge', b));
      });
      card.appendChild(badges);
      return card;
    }

    function techCard(setup) {
      var card = el('article', 'hm-konf__card hm-konf__tech');
      card.appendChild(txt('p', 'hm-konf__seclabel', S.s6_tech));
      var sys = state.plat.sys && state.plat.sys !== 'none' ? systemByKey(state.plat.sys) : null;
      var hub = state.plat.hubKey ? hubByKey(state.plat.hubKey) : null;
      var hubValue = S.s6_t_hub_none;
      if (setup.hubIncluded) hubValue = S.s6_t_hub_incl;
      else if (setup.hubMissing) hubValue = S.s6_t_hub_missing;
      else if (setup.verdict === 'green' && hub) hubValue = interpolate(S.s6_t_hub_own, { hub: hub.name });
      else if (setup.verdict === 'green' && state.plat.assumeTbr) hubValue = S.s6_t_hub_assumed;
      var rows = [
        [S.s6_t_eco, sys ? sys.name : S.s6_t_eco_open],
        [S.s6_t_hub, hubValue],
        [S.s6_t_local, setup.allMatter ? S.s6_t_local_v : S.s6_t_local_v_mixed],
        [S.s6_t_multi, setup.allMatter ? S.s6_t_multi_v : S.s6_t_multi_v_mixed]
      ];
      var dl = el('dl', 'hm-konf__tech-list');
      rows.forEach(function (r) {
        var row = el('div', 'hm-konf__tech-row');
        row.appendChild(txt('dt', 'hm-konf__tech-k', r[0]));
        row.appendChild(txt('dd', 'hm-konf__tech-v', r[1]));
        dl.appendChild(row);
      });
      card.appendChild(dl);
      return card;
    }

    function saveCard(setup) {
      var card = el('article', 'hm-konf__card hm-konf__savecard');
      card.appendChild(txt('p', 'hm-konf__seclabel', S.s6_save));
      card.appendChild(txt('p', 'hm-konf__savecard-sub', S.s6_save_sub));

      var saveBtn = el('button', 'hm-konf__btn hm-konf__btn--ghost hm-konf__btn--block', { type: 'button' });
      saveBtn.innerHTML = svg('save', 16) + '<span></span>';
      saveBtn.querySelector('span').textContent = S.s6_save_btn;
      saveBtn.addEventListener('click', function () { saveConfig(saveBtn); });
      card.appendChild(saveBtn);
      var note = el('p', 'hm-konf__savecard-note', { role: 'status', 'aria-live': 'polite' });
      note.textContent = S.s6_save_note;
      card.appendChild(note);

      // E-Mail-Versand: erst sichtbar, wenn die Konfigurator-App (App Proxy) antwortet
      if (appAvailable) {
        var form = el('form', 'hm-konf__mailrow');
        var input = el('input', 'hm-konf__mail', { type: 'email', required: 'required', placeholder: S.s6_mail_ph, 'aria-label': S.s6_mail_ph, autocomplete: 'email' });
        var send = el('button', 'hm-konf__btn hm-konf__btn--dark', { type: 'submit' });
        send.textContent = S.s6_mail_btn;
        form.appendChild(input);
        form.appendChild(send);
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          fetch(data.proxy.replace(/\/$/, '') + '/configs/email', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: input.value, state: state, url: shareUrl(), payload: setupPayload(setup) })
          }).then(function (res) {
            note.textContent = res.ok ? S.s6_mail_done : S.s6_mail_error;
          }).catch(function () { note.textContent = S.s6_mail_error; });
        });
        card.appendChild(form);
      }

      var chat = el('button', 'hm-konf__chatlink', { type: 'button', 'data-help-chat': '' });
      chat.innerHTML = svg('chat', 16) + '<span></span>';
      chat.querySelector('span').textContent = S.s6_chat;
      // Setup direkt in den Crisp-Chat übergeben: help.js öffnet den Chat ([data-help-chat]),
      // wir schicken zusätzlich die Konfiguration als erste Nachricht + Session-Daten fürs
      // Team. WICHTIG: verzögert senden — unser Button-Listener läuft VOR der help.js-
      // Delegation (chat:show/chat:open), und ein geladenes Crisp verwirft message:send,
      // solange das Widget noch versteckt ist.
      chat.addEventListener('click', function () {
        window.setTimeout(function () { pushSetupToChat(setup); }, 300);
      });
      card.appendChild(chat);
      if (data.hours) card.appendChild(txt('p', 'hm-konf__chathours', data.hours));
      return card;
    }

    function pushSetupToChat(setup) {
      try {
        var payload = setupPayload(setup);
        if (!payload) return;
        var url = shareUrl();
        // Pro Setup nur einmal senden — sonst spammt jeder weitere Klick den Chatverlauf.
        var sig = payload.goal + '|' + payload.total + '|' + payload.items.length;
        window.$crisp = window.$crisp || [];
        window.$crisp.push(['set', 'session:data', [[
          ['konfigurator_setup', payload.label + ' (' + money(payload.total) + ')'],
          ['konfigurator_link', url]
        ]]]);
        if (mount.__chatSig === sig) return;
        mount.__chatSig = sig;
        var lines = [S.chat_msg_intro];
        lines.push(payload.label + ' · ' + money(payload.total));
        payload.items.forEach(function (it) {
          lines.push(interpolate(S.s6_qty, { n: it.qty }) + ' ' + it.title);
        });
        lines.push(S.chat_msg_link + ' ' + url);
        window.$crisp.push(['do', 'message:send', ['text', lines.join('\n')]]);
      } catch (e) {}
    }

    function autosCard(setup) {
      var card = el('article', 'hm-konf__card');
      card.appendChild(txt('p', 'hm-konf__seclabel', S.s6_autos));
      var list = el('ul', 'hm-konf__autos');
      // Automationen: nur Texte, deren Gerät wirklich im Set liegt (requires-Feld im
      // Blueprint) — sonst verspricht die Karte z. B. einen Rauchmelder, der wegen der
      // Aufwands-Constraint gar nicht enthalten ist.
      function inSet(handle) {
        return setup.rows.some(function (r) { return r.handle === handle; });
      }
      var autos = (Array.isArray(setup.bp.autos) ? setup.bp.autos : []).filter(function (a) {
        return a && a.text && (!a.requires || inSet(a.requires));
      });
      var picked = autos.filter(function (a) {
        return Array.isArray(a.situations) && a.situations.some(function (s) { return state.sits.indexOf(s) !== -1; });
      });
      autos.forEach(function (a) {
        if (picked.length >= 3) return;
        if (picked.indexOf(a) !== -1) return;
        if (!Array.isArray(a.situations) || !a.situations.length) picked.push(a);
      });
      autos.forEach(function (a) {
        if (picked.length >= 3) return;
        if (picked.indexOf(a) === -1) picked.push(a);
      });
      picked.slice(0, 3).forEach(function (a) {
        var li = el('li', 'hm-konf__auto');
        var ico = el('span', 'hm-konf__auto-ico');
        ico.innerHTML = svg('bolt', 16);
        li.appendChild(ico);
        li.appendChild(txt('span', '', a.text || ''));
        list.appendChild(li);
      });
      card.appendChild(list);
      return card;
    }

    function roadmapCard(setup) {
      var entries = (Array.isArray(setup.bp.roadmap) ? setup.bp.roadmap : []).filter(function (r) {
        if (!r || !r.product) return false;
        var inSet = setup.rows.some(function (row) { return row.handle === r.product; });
        return !inSet && product(r.product);
      }).slice(0, 3);
      if (!entries.length) return null;
      var card = el('article', 'hm-konf__card hm-konf__roadmap');
      card.appendChild(txt('p', 'hm-konf__seclabel', S.s6_roadmap));
      card.appendChild(txt('p', 'hm-konf__roadmap-sub', S.s6_roadmap_sub));
      var list = el('ol', 'hm-konf__roadmap-list');
      entries.forEach(function (r, i) {
        var p = product(r.product);
        var li = el('li', 'hm-konf__roadmap-row');
        li.appendChild(txt('span', 'hm-konf__roadmap-num', String(i + 1)));
        var link = el('a', 'hm-konf__roadmap-label', { href: p.url });
        link.textContent = r.label || p.name || p.title;
        li.appendChild(link);
        li.appendChild(txt('span', 'hm-konf__roadmap-price', interpolate(S.s6_from, { price: money(p.price) })));
        list.appendChild(li);
      });
      card.appendChild(list);
      return card;
    }

    function altsRow(setup) {
      var candidates = [];
      var cheap = computeSetup('cheap');
      if (cheap && cheap.total < setup.total) {
        candidates.push({ key: 'cheap', title: S.s6_alt_cheap, text: S.s6_alt_cheap_sub, total: cheap.total });
      }
      var more = computeSetup('more');
      if (more && more.total > setup.total) {
        candidates.push({ key: 'more', title: S.s6_alt_more, text: S.s6_alt_more_sub, total: more.total });
      }
      var nohub = computeSetup('nohub');
      if (setup.hubIncluded && nohub && nohub.rows.length >= 2) {
        candidates.push({ key: 'nohub', title: S.s6_alt_nohub, text: S.s6_alt_nohub_sub, total: nohub.total });
      }
      if (state.override) {
        var base = computeSetup('');
        if (base) candidates.unshift({ key: '', title: S.s6_alt_base, text: S.s6_alt_base_sub, total: base.total });
      }
      candidates = candidates.filter(function (c) { return c.key !== state.override; });
      if (!candidates.length) return null;

      var wrap = el('section', 'hm-konf__alts-wrap');
      wrap.appendChild(txt('h3', 'hm-konf__alts-title', S.s6_alts));
      wrap.appendChild(txt('p', 'hm-konf__alts-sub', S.s6_alts_sub));
      var row = el('div', 'hm-konf__alts');
      candidates.slice(0, 3).forEach(function (c) {
        var card = el('article', 'hm-konf__alt');
        card.appendChild(txt('p', 'hm-konf__alt-title', c.title));
        card.appendChild(txt('p', 'hm-konf__alt-text', c.text));
        var foot = el('div', 'hm-konf__alt-foot');
        foot.appendChild(txt('strong', 'hm-konf__alt-price', money(c.total)));
        var btn = el('button', 'hm-konf__btn hm-konf__btn--ghost', { type: 'button' });
        btn.textContent = S.s6_alt_select;
        btn.addEventListener('click', function () {
          state.override = c.key;
          persist(state);
          render(true);
          window.scrollTo({ top: 0, behavior: reduceMotion() ? 'auto' : 'smooth' });
        });
        foot.appendChild(btn);
        card.appendChild(foot);
        row.appendChild(card);
      });
      wrap.appendChild(row);
      return wrap;
    }

    // ---------- Warenkorb ----------
    var addingSetup = false; // Flow-Flag statt Button-Attribut: Re-Renders erzeugen neue Buttons
    function addSetupToCart(setup, btn) {
      if (!Homedia.cart || !Homedia.cart.add) return;
      if (addingSetup) return;
      addingSetup = true;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-busy');
      // Note/CTA nach jedem Async-Schritt frisch holen — der Schritt kann re-rendert worden sein.
      function noteEl() { return content.querySelector('.hm-konf__cta-note'); }
      function setNote(msg) {
        var note = noteEl();
        if (note) note.textContent = msg;
        announce(msg);
      }

      var items = setup.rows.map(function (r) { return { id: r.p.variant, quantity: r.qty }; });
      if (setup.hubIncluded) items.push({ id: setup.hub.variant, quantity: 1 });

      Promise.resolve(Homedia.cart.add({ items: items }))
        .then(function () { return fetch(route('cart.js')).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          var disc = discountFor(cart.total_price || 0);
          var payload = { attributes: { _konfigurator: setup.goal + '|' + setup.scope + '|' + setup.verdict } };
          // Code nur anwenden, wenn die Staffel wirklich greift (sonst irritiert der Checkout).
          if (disc) payload.discount = disc.code;
          return fetch(route('cart/update.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          }).then(function (res) {
            // Erfolg nur melden, wenn der Code laut Response wirklich am Warenkorb hängt.
            if (!disc || !res.ok) return null;
            return res.json().then(function (updated) {
              var apps = updated && updated.cart_level_discount_applications;
              var applied = Array.isArray(apps) && apps.some(function (a) { return a && a.title === disc.code; });
              return applied ? disc : null;
            }).catch(function () { return null; });
          });
        })
        .then(function (disc) {
          setNote(disc
            ? interpolate(S.s6_added_discount, { code: disc.code, pct: disc.pct })
            : S.s6_added);
          emit('konfigurator:add', { goal: setup.goal, total: setup.total, items: setup.rows.length + (setup.hubIncluded ? 1 : 0) });
        })
        .catch(function () {
          setNote(S.s6_add_error);
        })
        .then(function () {
          addingSetup = false;
          [btn, content.querySelector('.hm-konf__cta')].forEach(function (b) {
            if (b) { b.removeAttribute('aria-busy'); b.classList.remove('is-busy'); }
          });
        });
    }
    function route(path) {
      var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return (r.charAt(r.length - 1) === '/' ? r : r + '/') + path;
    }

    // ---------- Speichern ----------
    function shareUrl() {
      var base = window.location.origin + window.location.pathname;
      return base + '?c=' + encodeState(state);
    }
    // Aufbereitete Setup-Zusammenfassung für die Konfigurator-App (E-Mail/Konto-Liste):
    // die App rendert daraus, ohne die Empfehlungs-Engine nachbauen zu müssen (docs/25 §7).
    function setupPayload(setupOrNull) {
      var setup = setupOrNull || computeSetup();
      if (!setup) return null;
      var items = setup.rows.map(function (r) {
        return { title: r.p.name || r.p.title, handle: r.handle, qty: r.qty, price: r.p.price, url: r.p.url };
      });
      if (setup.hubIncluded) {
        items.push({ title: setup.hub.name || setup.hub.title, handle: data.hubProduct, qty: 1, price: setup.hub.price, url: setup.hub.url });
      }
      return { label: setup.bp.label || '', goal: setup.goal, total: setup.total, items: items };
    }
    function saveConfig(btn) {
      persist(state);
      var url = shareUrl();
      var copied = false;
      function done() {
        emit('konfigurator:save', { goal: primaryGoal(), step: state.step });
        flashSaved(btn, copied ? S.saved_link : S.saved);
      }
      // Server-Sync über die Konfigurator-App (nur eingeloggt + App erreichbar)
      if (appAvailable && data.customer && data.customer.loggedIn) {
        fetch(data.proxy.replace(/\/$/, '') + '/configs', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ state: state, url: url, payload: setupPayload(null) })
        }).catch(function () {});
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () { copied = true; done(); }, done);
      } else {
        done();
      }
    }
    function flashSaved(btn, message) {
      announce(message);
      var toast = el('span', 'hm-konf__saved');
      toast.innerHTML = svg('check', 13) + '<span></span>';
      toast.querySelector('span').textContent = message;
      btn.parentNode.insertBefore(toast, btn);
      window.setTimeout(function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 3200);
    }

    // ---------- Untere Leiste ----------
    function renderBar() {
      bottombar.innerHTML = '';
      if (state.step >= 6) { bottombar.hidden = true; return; }
      bottombar.hidden = false;

      var inner = el('div', 'hm-konf__bar-inner');

      var back = el('button', 'hm-konf__btn hm-konf__btn--ghost hm-konf__back', { type: 'button', 'aria-label': S.back });
      back.innerHTML = svg('arrowl', 16) + '<span></span>';
      back.querySelector('span').textContent = S.back;
      if (state.step === 1) back.classList.add('is-hidden');
      back.addEventListener('click', function () { if (state.step > 1) goto(state.step - 1); });
      inner.appendChild(back);

      var mid = el('div', 'hm-konf__bar-mid', { 'aria-live': 'polite' });
      if (errorNow) {
        var err = el('p', 'hm-konf__bar-error');
        err.innerHTML = svg('info', 15) + '<span></span>';
        err.querySelector('span').textContent = errorNow;
        mid.appendChild(err);
      } else {
        var chips = summaryChips();
        if (chips.length) {
          var chipsWrap = el('div', 'hm-konf__bar-chips');
          chips.forEach(function (c) {
            var s = el('span', 'hm-konf__bar-chip');
            s.innerHTML = svg('check', 11) + '<span></span>';
            s.querySelector('span').textContent = c;
            chipsWrap.appendChild(s);
          });
          mid.appendChild(chipsWrap);
        } else {
          mid.appendChild(txt('p', 'hm-konf__bar-hint', S['h' + state.step] || ''));
        }
      }
      inner.appendChild(mid);

      var next = el('button', 'hm-konf__btn hm-konf__btn--accent hm-konf__next', { type: 'button' });
      next.innerHTML = '<span></span>' + svg('arrow', 16);
      next.querySelector('span').textContent = S['next_' + (state.step + 1)];
      next.addEventListener('click', tryNext);
      inner.appendChild(next);

      bottombar.appendChild(inner);
    }

    function summaryChips() {
      var chips = [];
      if (state.goals.length) {
        var first = S['goal_' + state.goals[0]];
        chips.push(state.goals.length > 1 ? first + ' +' + (state.goals.length - 1) : first);
      }
      if (state.home.form) chips.push(state.home.form === 'haus' ? S.s2_haus : S.s2_wohnung);
      if (state.home.budget) chips.push(S['s2_' + state.home.budget]);
      if (state.plat.sys) {
        var sys = systemByKey(state.plat.sys);
        if (sys) chips.push(sys.name);
      }
      if (state.rooms.length) chips.push(interpolate(S.chip_rooms, { n: state.rooms.length }));
      if (state.sits.length) chips.push(interpolate(S.chip_sits, { n: state.sits.length }));
      return chips.slice(0, 6);
    }

    // ---------- Express-Modus ----------
    function openExpress() {
      var panel = document.getElementById('konf-express');
      if (!panel) return;
      var body = panel.querySelector('[data-konf-express-body]');
      if (body) buildExpress(body, panel);
      emit('konfigurator:express', {});
      if (Homedia.overlay && Homedia.overlay.open) Homedia.overlay.open(panel);
      else panel.hidden = false;
    }
    function buildExpress(body, panel) {
      // Express-Zwischenstand am Mount-Element halten: buildExpress rendert bei jeder
      // Auswahl neu, die Antworten müssen die Re-Renders überleben.
      if (!body.__ex) body.__ex = { sys: '', tbr: false, goal: '', budget: '' };
      var ex = body.__ex;
      body.innerHTML = '';

      var badge = el('p', 'hm-konf__ex-badge');
      badge.innerHTML = svg('bolt', 13) + '<span></span>';
      badge.querySelector('span').textContent = S.ex_badge;
      body.appendChild(badge);
      body.appendChild(txt('h2', 'hm-konf__ex-title', S.ex_title));
      body.appendChild(txt('p', 'hm-konf__ex-sub', S.ex_sub));

      var err = el('p', 'hm-konf__bar-error hm-konf__ex-error', { 'aria-live': 'polite' });
      err.hidden = true;

      function pillRow(labelText, options, get, set, extraBuild) {
        var block = el('div', 'hm-konf__ex-q');
        block.appendChild(txt('p', 'hm-konf__q-label', labelText));
        var row = el('div', 'hm-konf__chips');
        options.forEach(function (o) {
          row.appendChild(chip(o[1], get() === o[0], function () {
            set(get() === o[0] ? '' : o[0]);
            err.hidden = true;
            buildExpress(body, panel);
          }));
        });
        block.appendChild(row);
        if (extraBuild) extraBuild(block);
        body.appendChild(block);
      }

      pillRow(S.ex_q1, systems.map(function (sy) { return [sy.key, sy.name]; }),
        function () { return ex.sys; },
        function (v) { ex.sys = v; if (v === 'none' || !v) ex.tbr = false; },
        function (block) {
          if (ex.sys && ex.sys !== 'none') {
            var lab = el('label', 'hm-konf__ex-tbr');
            var cb = el('input', '', { type: 'checkbox' });
            if (ex.tbr) cb.setAttribute('checked', 'checked');
            cb.addEventListener('change', function () { ex.tbr = cb.checked; });
            lab.appendChild(cb);
            lab.appendChild(txt('span', '', S.ex_tbr));
            block.appendChild(lab);
          }
        });
      pillRow(S.ex_q2, GOALS.map(function (g) { return [g, S['goal_' + g]]; }),
        function () { return ex.goal; }, function (v) { ex.goal = v; });
      pillRow(S.ex_q3, [['b1', S.s2_b1], ['b2', S.s2_b2], ['b3', S.s2_b3], ['b4', S.s2_b4]],
        function () { return ex.budget; }, function (v) { ex.budget = v; });

      body.appendChild(err);

      var cta = el('button', 'hm-konf__btn hm-konf__btn--accent hm-konf__btn--block', { type: 'button' });
      cta.textContent = S.ex_cta;
      cta.addEventListener('click', function () {
        if (!ex.sys || !ex.goal || !ex.budget) {
          err.textContent = S.ex_error;
          err.hidden = false;
          return;
        }
        state = blankState();
        state.goals = [ex.goal];
        state.home.budget = ex.budget;
        state.plat.sys = ex.sys;
        if (ex.sys === 'none') { state.plat.noHub = false; }
        else if (ex.tbr) { state.plat.assumeTbr = true; }
        else { state.plat.noHub = true; }
        body.__ex = null;
        if (Homedia.overlay && Homedia.overlay.close) Homedia.overlay.close(document.getElementById('konf-express'));
        goto(6);
      });
      body.appendChild(cta);
    }

    // ---------- App-Proxy-Feature-Detection (Konfigurator-App, docs/25) ----------
    if (data.proxy) {
      fetch(data.proxy.replace(/\/$/, '') + '/ping', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (json) {
          if (json && json.ok) {
            appAvailable = true;
            if (state.step === 6) render(false);
          }
        })
        .catch(function () {});
    }

    // Kick-off: Share-Links öffnen auf dem GESPEICHERTEN Schritt (Ergebnis-Links auf 6,
    // Zwischenstände dort, wo gespeichert wurde). Schritt 6 ohne Ziel ist oben schon
    // auf Schritt 1 zurückgesetzt; alles Weitere hat sanitizeState geprüft.
    render(false);
    if (shareInvalid) announce(S.share_invalid);

    Homedia.konfigurator = { getState: function () { return state; } };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
